import React from 'react';

function Services() {
  return (
    <div className="slds-grid slds-gutters">
      <div className="slds-col slds-size_1-of-1">
        <div className="slds-card">
          <div className="slds-card__body slds-card__body_inner">
            <h1 className="slds-text-heading_large slds-p-bottom_medium">Our Services</h1>
            
            <div className="slds-text-longform">
              <h2 className="slds-text-heading_medium slds-p-bottom_small">ABA Therapy</h2>
              <p className="slds-p-bottom_medium">
                Our Applied Behavior Analysis (ABA) therapy is an evidence-based approach that focuses on improving specific 
                behaviors and skills. We develop individualized treatment plans that address:
              </p>
              
              <ul className="slds-has-dividers_bottom-space slds-p-bottom_medium">
                <li className="slds-item">Communication skills</li>
                <li className="slds-item">Social skills</li>
                <li className="slds-item">Daily living skills</li>
                <li className="slds-item">Behavior management</li>
                <li className="slds-item">Academic skills</li>
              </ul>

             
              <h2 className="slds-text-heading_medium slds-p-bottom_small slds-p-top_medium">Our Treatment Process</h2>
              <div className="slds-grid slds-gutters slds-p-bottom_medium slds-grid_vertical-align-stretch">
                <div className="slds-col slds-size_1-of-3">
                  <div className="slds-card slds-card_boundary slds-card_full">
                    <div className="slds-card__header slds-grid">
                      <header className="slds-media slds-media_center slds-has-flexi-truncate">
                        <div className="slds-media__figure">
                          <span className="slds-icon_container slds-icon-standard-task" title="Assessment">
                            <svg className="slds-icon slds-icon_small" aria-hidden="true">
                              <use xlinkHref="/assets/icons/standard-sprite/svg/symbols.svg#task"></use>
                            </svg>
                          </span>
                        </div>
                        <div className="slds-media__body">
                          <h2 className="slds-card__header-title">
                            <span className="slds-text-heading_medium">1. Assessment</span>
                          </h2>
                        </div>
                      </header>
                    </div>
                    <div className="slds-card__body slds-card__body_inner slds-grid slds-grid_vertical-align-end">
                      <p className="slds-text-body_regular">
                        Comprehensive evaluation of skills and behaviors to develop an individualized treatment plan.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="slds-col slds-size_1-of-3">
                  <div className="slds-card slds-card_boundary slds-card_full">
                    <div className="slds-card__header slds-grid">
                      <header className="slds-media slds-media_center slds-has-flexi-truncate">
                        <div className="slds-media__figure">
                          <span className="slds-icon_container slds-icon-standard-custom" title="Treatment">
                            <svg className="slds-icon slds-icon_small" aria-hidden="true">
                              <use xlinkHref="/assets/icons/standard-sprite/svg/symbols.svg#custom"></use>
                            </svg>
                          </span>
                        </div>
                        <div className="slds-media__body">
                          <h2 className="slds-card__header-title">
                            <span className="slds-text-heading_medium">2. Treatment</span>
                          </h2>
                        </div>
                      </header>
                    </div>
                    <div className="slds-card__body slds-card__body_inner slds-grid slds-grid_vertical-align-end">
                      <p className="slds-text-body_regular">
                        Implementation of evidence-based interventions by our qualified team of professionals.
                      </p>
                    </div>
                  </div>
                </div>

                <div className="slds-col slds-size_1-of-3">
                  <div className="slds-card slds-card_boundary slds-card_full">
                    <div className="slds-card__header slds-grid">
                      <header className="slds-media slds-media_center slds-has-flexi-truncate">
                        <div className="slds-media__figure">
                          <span className="slds-icon_container slds-icon-standard-metrics" title="Progress Monitoring">
                            <svg className="slds-icon slds-icon_small" aria-hidden="true">
                              <use xlinkHref="/assets/icons/standard-sprite/svg/symbols.svg#metrics"></use>
                            </svg>
                          </span>
                        </div>
                        <div className="slds-media__body">
                          <h2 className="slds-card__header-title">
                            <span className="slds-text-heading_medium">3. Progress Monitoring</span>
                          </h2>
                        </div>
                      </header>
                    </div>
                    <div className="slds-card__body slds-card__body_inner slds-grid slds-grid_vertical-align-end">
                      <p className="slds-text-body_regular">
                        Regular assessment and adjustment of treatment plans to ensure optimal progress.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Services; 